import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		position          : "relative",
		display           : "flex",
		alignItems        : "center",
		marginLeft        : "5px",
		"& :last-of-type" : {
			marginRight: "0 !important"

		},
		cursor                  : "pointer",
		WebkitTapHighlightColor : "transparent"
	},
	menuContainer: {
		"& .MuiMenu-profile-social": {
			backgroundColor : theme.other.colors.background.tertiary,
			boxShadow       : `${ theme.other.colors.boxShadow.primary } !important`
		}
	},
	menuItem: {
		"&:hover": {
			//   backgroundColor: "#fff !important"
		}
	},
	socialMediaIcon: {
		width  : "18px",
		height : "18px"
	},
	igIcon: {
		marginRight: "-8px"
	},
	ytIcon: {
		marginRight: "-8px"
	},
	listItem: {
		marginLeft : "1rem !important",
		flex       : "1"
		// fontSize: "0.9rem"
	},
	anchorText: {
		textDecoration : "none",
		color          : "black",
		display        : "flex"
	}
} ) );
